import { lStorage, sStorage } from "@Comm/js/Storage.js"



//2022-10-30 添加:sessionstorage的存放用户数据  开始
export function setUserSessio(content){
        // console.log("setUserSessio");
        // sStorage.setItem(lStorage.WX_USER_ID, [{‘’}}])
        sStorage.setItem('token',content.token);
        sStorage.setItem('UserInfo',
          {'bTC':content.bTC,
          'bTC_address':content.bTC_address,
          'eTH':content.eTH,
          'eTH_address':content.eTH_address,
          'uSDT':content.uSDT,
          'uSDT_address':content.uSDT_address,
          'login_IP':content.login_IP,
          'mail':content.mail,
          'id':content.id,
          'tn':content.tn,
          'type':content.type,
          'creationTime':content.creationTime,
          'updateTime':content.updateTime,
          'token':content.token});
      //  console.log("session:"+  sStorage.getItem('token'));
  }
//2022-10-30 添加:sessionstorage的存放用户数据  结束



// WEBPACK FOOTER //
// ./src/OK_Scott/assets/js/UserStorage.js